import React from 'react';
import { PricingVariant } from '@wix/ambassador-pricing-plans-v3-plan/types';
import { VIEWER_HOOKS } from '@wix/pricing-plans-common/hooks';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { getVariantFreeTrialDaysLabel } from '../../../../../utils/plan';
import { st, classes } from './FreeTrial.st.css';

interface Props {
  variant: PricingVariant | undefined;
  freeTrialDaysExist: boolean;
  highlighted: boolean;
  className?: string;
}

export const FreeTrial: React.FC<Props> = ({ variant, freeTrialDaysExist, highlighted, className }) => {
  const { t } = useTranslation();

  if (!freeTrialDaysExist) {
    return null;
  }

  const label = getVariantFreeTrialDaysLabel(variant!, t);

  return (
    <span data-hook={VIEWER_HOOKS.PLAN_FREE_TRIAL} className={st(classes.duration, { highlighted }, className)}>
      {label}
    </span>
  );
};
